import { Location } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-voltar',
  templateUrl: './voltar.component.html',
  styleUrls: ['./voltar.component.scss']
})
export class VoltarComponent implements OnInit {
  @Input() route: string = '';

  constructor(
    private router: Router,
    private location: Location
  ) {}

  ngOnInit() {}

  voltar() {
    if (this.route === '') {
      this.location.back();
      return;
    }
    this.router.navigate([this.route]);
  }
}
